module.exports = __webpack_public_path__ + "static/media/3DPPA42.e02b9607.jpg";